const JIVO_KEY = 'Rpo7fYDz9n'
export const createJivoChat = () => {
  const script = document.createElement('script')
  script.src = `//code.jivo.ru/widget/${JIVO_KEY}`
  script.setAttribute('async', '')
  document.body.append(script)
}
